module.exports = __webpack_public_path__ + "img/12_financial-wellness.11ffdb5d.png";